import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');
    return (
        <div className="sp-220-double-F">
            <div className="info-box">
                <p className="title">{t('F_title')}</p>
                <p className="desc">{t('F_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/solar-panel-220w-double/6.jpg"
                    srcPad="/responsive/picture/solar-panel-220w-double/6_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-220w-double/6_768.jpg"
                    alt={t('F_title')}
                />
            </div>
        </div>
    );
}
